import localeIt from '@angular/common/locales/it';
import { SharedModule } from '@shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { ModalErrorComponent } from './components/modal-error/modal-error.component';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorService } from './interceptors/http-interceptor/http-interceptor.service';
import { AuthInterceptorService } from './interceptors/auth-interceptor/auth-interceptor.service';
import { HttpErrorInterceptorService } from './interceptors/http-error-interceptor/http-error-interceptor.service';
import { environment } from '@environments/environment';
import { ModalLoaderComponent } from './components/modal-loader/modal-loader.component';
import { BiometricVaultService } from './services/biometric-vault/biometric-vault.service';

registerLocaleData(localeIt);

const appInitFactory =
  (vaultService: BiometricVaultService): (() => Promise<void>) =>
  () =>
    vaultService.init();

@NgModule({
  declarations: [ModalErrorComponent, ModalLoaderComponent],
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    { provide: LOCALE_ID, useValue: environment.locale || 'it-IT' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitFactory,
      deps: [BiometricVaultService],
      multi: true
    }
  ]
})
export class CoreModule {}
